    <template>
    <div>
        <a-drawer v-if="drawerVisible" title="" :width="480" placement="right" @close="onClose" :visible="drawerVisible">

            <br>

            <div v-if="type == 'a'">
                <base-input label="Select Accounts on the List">
                    <br/>
                    <a-select v-model="accountIds" mode="multiple" showSearch placeholder="Search Account" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in accountOptions" :key="option.id" :value="option.id">{{option.account_name}}</a-select-option>
                    </a-select>
                </base-input>
            </div>

            <div v-if="type == 's'">
                <h6 class="heading-small text-muted pb-3">Select sites where updated version will be deployed</h6>
                <base-input label="Select Sites on the List">
                    <br/>
                    <a-select v-model="siteIds" mode="multiple" showSearch placeholder="Search Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>

                <!-- <div class="float-right" style="position: absolute; bottom: 20px; right: 20px;">
                    <button class="btn btn-primary" @click.prevent="onClose">Cancel</button>
                </div> -->
            </div>

            <div v-if="type == 'd'">
                <h6 class="heading-small text-muted pb-3">Select terminals where updated version will be deployed</h6>
                <base-input label="Select Devices on the List">
                    <br/>
                    <a-select v-model="deviceIds" mode="multiple" showSearch placeholder="Search Site" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" :notFoundContent="fetching ? undefined : null" @search="handleSearch">
                        <a-spin v-if="fetching" slot="notFoundContent" size="small" />
                        <a-select-option v-for="option in deviceOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                    </a-select>
                </base-input>

            </div>

        </a-drawer>

            <div class="card mb-3">
                <div class="row no-gutters" style="min-height: 56vh; overflow: auto;">
                    <div class="col-md-3" style="border-right: 1px solid #e0e0e0">
                        <div class="card-body">
                            <div class="row">
                                <h3 class="col card-title pt-1">Wavelets</h3>
                                <div  v-if="isRippleAdmin">
                                    <small class="heading-small mr-2">STATUS</small>
                                    <a-select v-model='waveletFilterStatus' style="width: 120px" @change="filterStatus">
                                        <a-select-option value="0">
                                            All
                                        </a-select-option>
                                        <a-select-option value="O">
                                            Development
                                        </a-select-option>
                                        <a-select-option value="L">
                                            Live
                                        </a-select-option>
                                        <a-select-option value="P" >
                                            For Approval
                                        </a-select-option>
                                        <a-select-option value="D">
                                            Deactivated
                                        </a-select-option>
                                    </a-select>
                                </div>
                                <div v-if="!isRippleAdmin" class="col">
                                    <button v-if='mode!="create_wavelet"' @click="changeMode('create_wavelet')" class='float-right mx-1 btn btn-sm btn-primary' style="border-radius: 24px; background-color: #0569FF; border:0px; width: 100%;" type="primary">+ Create</button>
                                    <a-popconfirm v-else @confirm="() => changeMode('')" ok-text="Yes" cancel-text="No" title='Are you sure you want to cancel?' style="border-radius: 24px; border:0px; width: 50%;" class="float-right mx-1 btn btn-sm btn-danger">Cancel</a-popconfirm>
                                </div>
                            </div>
                            <div class="row mb-2">
                                <div class="col"><a-input-search placeholder="Search" style="width: 100%" @search="onSearch" /></div>
                            </div>
                            <div class="row">
                                <div v-if="wavelets.length > 0" class="col">
                                    <a-table rowKey="id" :pagination="{pageSize: 7}" size="middle"  :showHeader='false' :columns="waveletColumns" :data-source="wavelets">
                                        <!-- :class="[{selected2: selectedModule.id == system_module.id}]" -->
                                        <template slot="info" slot-scope="text, record">
                                            <span @click.prevent="openWavelet(record.id)">{{record.name | truncate(30, '...')}}</span> <br>
                                            <!-- <small v-if="!isRippleAdmin" >{{record.description | truncate(30, '...')}}</small>  -->
                                            <!-- <small v-else>{{record.developer_account_name | truncate(30, '...')}}</small> -->

                                        </template>
                                        <template slot="action" slot-scope="text, record">
                                            <div class='d-flex justify-content-end align-items-center'>
                                                    <a-tag class='float-right' v-if="record.status == 'O'" color="orange">Development</a-tag>
                                                    <a-tag class='float-right' v-if="record.status == 'D'" color="red">Deleted</a-tag>
                                                    <a-tag class='float-right' v-if="record.status == 'P'" color="red">For Approval</a-tag>
                                                    <a-tag class='float-right' v-if="record.status == 'L'" color="green">Live</a-tag>
                                                    <!-- <button @click="openWavelet(record.id)" class='btn btn-sm btn-primary' type="primary">Open</button> -->
                                            </div>
                                        </template>
                                    </a-table>
                                </div>
                                <div v-else class='col'>
                                    <hr class="mt-0 mb-3">
                                    <small>No wavelets found</small>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-9">
                        <div v-if='mode=="configuration"' class="card-body">

                            <div class="row">
                                <h3 class="col card-title fix-overflow">Configuration - {{waveletName}}</h3>
                                <div class="col steps-action">
                                    <button class='float-right mx-1 btn btn-sm btn-primary' v-if="current < steps.length - 1 && (webUploadChecked || posUploadChecked || appUploadChecked || pdtUploadChecked)" type="primary" @click="submitWavelets">
                                        Next
                                    </button>

                                    <button class="float-right mx-1 btn btn-sm btn-success" v-if="current == steps.length - 1 && !isRippleAdmin" type="primary" @click="confirmWavelets" :disabled='this.webWaveletId > 0 || this.posWaveletId > 0'>
                                        Publish
                                    </button>
                                    <button class="float-right mx-1 btn btn-sm btn-success" v-else-if="current == steps.length - 1 && waveletStatus == 'P'" type="primary" @click="approveWavelet(waveletId)">
                                        Approve
                                    </button>

                                    <button v-if="current > 0" style="margin-left: 8px" @click="back"  class="float-right mx-1 btn btn-sm btn-primary">
                                        Back
                                    </button>
                                    <a-popconfirm @confirm="() => openWavelet(waveletId)" ok-text="Yes" cancel-text="No" title='Are you sure you want to cancel?' class="float-right mx-1 btn btn-sm btn-danger">Cancel</a-popconfirm>
                                </div>
                            </div>
                            <div class="row mx-2">
                                <a-steps :current="current">
                                    <a-step v-for="item in steps" :key="item.title" :title="item.title" />
                                </a-steps>
                            </div>
                            <div v-if="current == 0" class="col mt-4 steps-content" style="max-height: 80vh; overflow: auto;">
                                <div class="row">
                                    <div class="col-3"><a-checkbox :checked='webUploadChecked' @change="webCheckboxToggle" :disabled='this.webWaveletId > 0 || this.posWaveletId  > 0 || isRippleAdmin'>Web Wavelet</a-checkbox></div>
                                    <div class="col-3"><a-checkbox :checked='posUploadChecked' @change="posCheckboxToggle" :disabled='this.webWaveletId > 0 || this.posWaveletId  > 0 || isRippleAdmin'>POS Wavelet</a-checkbox></div>
                                    <div class="col-3"><a-checkbox :checked='pdtUploadChecked' @change="pdtCheckboxToggle" :disabled='this.webWaveletId > 0 || this.posWaveletId  > 0 || isRippleAdmin'>PDT Wavelet</a-checkbox></div>
                                    <div class="col-3"><a-checkbox :checked='appUploadChecked' @change="appCheckboxToggle" :disabled='this.webWaveletId > 0 || this.posWaveletId  > 0 || isRippleAdmin'>Other Apps</a-checkbox></div>
                                </div>
                                <div class="row mt-2" >
                                    <div class="col-3" style="height: 40%">
                                        <a-upload-dragger
                                                accept=".wvl"
                                                :file-list="webWaveletList"
                                                @change="handleChangeWeb"
                                                :remove="handleRemoveWeb"
                                                :before-upload="beforeUploadWeb"
                                                :disabled='!webUploadChecked || this.webWaveletId > 0'
                                        >
                                                    <p class="ant-upload-drag-icon" ><a-icon type="inbox" /></p>
                                                    <p class="ant-upload-text" >Click or drag file to this area to upload your web wavelet file</p>
                                                    <p class="ant-upload-hint">Supports single upload of wavelet file (.wvl)</p>
                                        </a-upload-dragger>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">Web Wavelet Price</h6>
                                            <a-input-number style="width: 100%" v-model='webWaveletPrice' placeholder="Web Wavelet Price" :disabled='!webUploadChecked || this.webWaveletId > 0'/>
                                            <small>This is the market price of your wavelet per user. The value above is subject to Wavelet Profit Sharing Agreement.</small>
                                        </div>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">EULA & Privacy Overview Files (.txt)</h6>

                                            <a-upload
                                                accept=".txt"
                                                :file-list="webWaveletTextFiles"
                                                @change="handleChangeWebText"
                                                :remove="handleRemoveWebText"
                                                :before-upload="beforeUploadWebText"
                                                :disabled='!webUploadChecked || this.webWaveletId > 0'
                                            >
                                                <a-button :disabled='!webUploadChecked || this.webWaveletId > 0'> <a-icon type="upload" /> Click to Upload </a-button>
                                            </a-upload>
                                            <template v-if='this.webWaveletId > 0'>
                                                <small>{{webFile1}}</small>
                                                <br>
                                                <small>{{webFile2}}</small>
                                            </template>
                                        </div>
                                    </div>
                                    <div class="col-3" style="height: 40%">
                                        <a-upload-dragger
                                            accept=".zip"
                                            :file-list="posWaveletList"
                                            @change="handleChangePos"
                                            :remove="handleRemovePos"
                                            :before-upload="beforeUploadPos"
                                            :disabled='!posUploadChecked || this.posWaveletId > 0'
                                            >
                                                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                                                <p class="ant-upload-text">Click or drag file to this area to upload your pos wavelet file</p>
                                                <p class="ant-upload-hint">Supports single upload of zip file (.zip)</p>
                                        </a-upload-dragger>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">POS Wavelet Price</h6>
                                            <a-input-number style="width: 100%" v-model='posWaveletPrice' placeholder="POS Wavelet Price" :disabled='!posUploadChecked || this.posWaveletId > 0'/>
                                            <small>This is the market price of your wavelet per user. The value above is subject to Wavelet Profit Sharing Agreement.</small>
                                        </div>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">EULA & Privacy Overview Files (.txt)</h6>
                                            <a-upload
                                                accept=".txt"
                                                :file-list="posWaveletTextFiles"
                                                @change="handleChangePosText"
                                                :remove="handleRemovePosText"
                                                :before-upload="beforeUploadPosText"
                                                :disabled='!posUploadChecked || this.posWaveletId > 0'
                                            >
                                                <a-button :disabled='!posUploadChecked || this.posWaveletId > 0'> <a-icon type="upload" /> Click to Upload </a-button>
                                            </a-upload>
                                            <template v-if='this.posWaveletId > 0'>
                                                <small>{{posFile1}}</small>
                                                <br>
                                                <small>{{posFile2}}</small>
                                            </template>
                                        </div>
                                    </div>
                                     <div class="col-3" style="height: 40%">
                                        <a-upload-dragger
                                            accept=".apk"
                                            :file-list="pdtWaveletList"
                                            @change="handleChangePdt"
                                            :remove="handleRemovePdt"
                                            :before-upload="beforeUploadPdt"
                                            :disabled='!pdtUploadChecked || this.pdtWaveletId > 0'
                                            >
                                                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                                                <p class="ant-upload-text">Click or drag file to this area to upload your pdt wavelet file</p>
                                                <p class="ant-upload-hint">Supports single upload of apk file (.apk)</p>
                                        </a-upload-dragger>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">PDT Wavelet Price</h6>
                                            <a-input-number style="width: 100%" v-model='appWaveletPrice' placeholder="Wavelet App Price" :disabled='!pdtUploadChecked || this.pdtWaveletId > 0'/>
                                            <small>This is the market price of your wavelet per device installed. The value above is subject to Wavelet Profit Sharing Agreement.</small>
                                        </div>
                                    </div>
                                    <div class="col-3" style="height: 40%">
                                        <a-upload-dragger
                                            accept=".zip"
                                            :file-list="appWaveletList"
                                            @change="handleChangeApp"
                                            :remove="handleRemoveApp"
                                            :before-upload="beforeUploadApp"
                                            :disabled='!appUploadChecked || this.appWaveletId > 0'
                                            >
                                                <p class="ant-upload-drag-icon"><a-icon type="inbox" /></p>
                                                <p class="ant-upload-text">Click or drag file to this area to upload your wavelet app file</p>
                                                <p class="ant-upload-hint">Supports single upload of zip file (.zip)</p>
                                        </a-upload-dragger>
                                        <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">Wavelet App Price</h6>
                                            <a-input-number style="width: 100%" v-model='appWaveletPrice' placeholder="Wavelet App Price" :disabled='!appUploadChecked || this.appWaveletId > 0'/>
                                            <small>This is the market price of your wavelet per device installed. The value above is subject to Wavelet Profit Sharing Agreement.</small>
                                        </div>
                                        <!-- <hr class='my-2'>
                                        <div class="col-12 mt-2 px-0">
                                            <h6 class="heading-small text-muted">EULA & Privacy Overview Files (.txt)</h6>
                                            <a-upload
                                                accept=".txt"
                                                :file-list="posWaveletTextFiles"
                                                @change="handleChangePosText"
                                                :remove="handleRemovePosText"
                                                :before-upload="beforeUploadPosText"
                                                :disabled='!posUploadChecked || this.posWaveletId > 0'
                                            >
                                                <a-button :disabled='!posUploadChecked || this.posWaveletId > 0'> <a-icon type="upload" /> Click to Upload </a-button>
                                            </a-upload>
                                            <template v-if='this.posWaveletId > 0'>
                                                <small>{{posFile1}}</small>
                                                <br>
                                                <small>{{posFile2}}</small>
                                            </template>
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div v-if="current == 1 && !(prevAppId > 0)" class="col mt-2 steps-content" style="max-height: 80vh; overflow: auto;">
                                <div v-if='isNewVersion==true' class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">Version</h6>
                                    <a-input-number style="width: 100%" v-model='waveletVersion' placeholder="Version" :disabled="mode=='open_wavelet'"/>
                                </div>
                                <a-tabs :default-active-key="tabDefaultActiveKey">
                                    <a-tab-pane :key="1" v-if='webUploadChecked==true'>
                                        <span slot="tab">
                                        <a-icon type="laptop" />
                                            Web Wavelet
                                        </span>
                                        <a-collapse v-model="webActiveKey">
                                            <a-collapse-panel key="1" header="Information">
                                                <div class="col-12 mt-2 mx-0 my-0">
                                                    <h6 class="heading-small text-muted">Name</h6>
                                                    <a-input v-model='webWaveletJson.name' placeholder="Name" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Author</h6>
                                                    <a-input v-model='webWaveletJson.author' placeholder="Author" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Company</h6>
                                                    <a-input v-model='webWaveletJson.company' placeholder="Company" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Definition</h6>
                                                    <a-input v-model='webWaveletJson.definition' placeholder="Definition" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Redirect Link</h6>
                                                    <a-input v-model='webWaveletJson.redirect_link' placeholder="Redirect Link" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Logo</h6>
                                                    <a-input v-model='webWaveletJson.logo' placeholder="Logo" :disabled='true'/>
                                                </div>
                                                <div v-if='webWaveletJson.tags!=undefined' class="col-12 mt-3">
                                                    <strong class="strong heading-small text-muted mr-2">Tags</strong>
                                                    <a-tag v-for="tags in webWaveletJson.tags.split(',')" :key="tags" color="geekblue">
                                                        {{tags}}
                                                    </a-tag>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="2" header="Permissions" >
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Profile</th>
                                                                <th scope="col">Methods</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, profile) in webWaveletJson.permissions">
                                                                <td>{{profile}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="methods"'>{{value.join(', ')}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="3" header="Modules">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Settings</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in webWaveletJson.modules">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="status"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="settings"'>
                                                                        <button class='btn btn-sm btn-info' type="primary" @click='showSettingDrawer(value)'>View</button>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                        </a-collapse>
                                    </a-tab-pane>
                                    <a-tab-pane :key="2" v-if='posUploadChecked==true'>
                                        <span slot="tab">
                                            <a-icon type="cluster" />
                                            POS Wavelet
                                        </span>
                                        <a-collapse v-model="posActiveKey">
                                            <a-collapse-panel key="4" header="Information">
                                                <div class="col-12 mt-2 mx-0 my-0">
                                                    <h6 class="heading-small text-muted">Name</h6>
                                                    <a-input v-model='posWaveletJson.name' placeholder="Name" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Author</h6>
                                                    <a-input v-model='posWaveletJson.author' placeholder="Author" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Company</h6>
                                                    <a-input v-model='posWaveletJson.company' placeholder="Company" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Version</h6>
                                                    <a-input v-model='posWaveletJson.version' placeholder="Version" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Definition</h6>
                                                    <a-input v-model='posWaveletJson.definition' placeholder="Definition" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Logo</h6>
                                                    <a-input v-model='posWaveletJson.logo' placeholder="Logo" :disabled='true'/>
                                                </div>
                                                <div v-if='posWaveletJson.tags!=undefined' class="col-12 mt-3">
                                                    <strong class="strong heading-small text-muted mr-2">Tags</strong>
                                                    <a-tag v-for="tags in posWaveletJson.tags.split(',')" :key="tags" color="geekblue">
                                                        {{tags}}
                                                    </a-tag>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="5" header="Permissions">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Profile</th>
                                                                <th scope="col">Methods</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, profile) in posWaveletJson.permissions">
                                                                <td>{{profile}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="methods"'>{{value.join(', ')}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="6" header="Events">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Function Name</th>
                                                                <th scope="col">Priority</th>
                                                                <th scope="col">Blocking</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in posWaveletJson.events">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="functionName"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="priority"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="blocking"'>{{value}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="7" header="Modules">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Settings</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in posWaveletJson.modules">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="status"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="settings"'>
                                                                        <button class='btn btn-sm btn-info' type="primary" @click='showSettingDrawer(value)'>View</button>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                        </a-collapse>
                                    </a-tab-pane>
                                    <a-tab-pane :key="3" v-if='appUploadChecked==true'>
                                         <span slot="tab">
                                            <span class="fa fa-mobile" />
                                            App Wavelet
                                        </span>
                                        <div class="col-12 mt-2 mx-0 my-0">
                                            <h6 class="heading-small text-muted">Path</h6>
                                            <a-input v-model='appSourcePath' placeholder="App Path" :disabled='true'/>

                                            <h6 class="heading-small text-muted">Price</h6>
                                            <a-input v-model='appWaveletPrice' placeholder="Price" :disabled='true'/>
                                        </div>
                                    </a-tab-pane>
                                    <a-tab-pane :key="3" v-if='pdtUploadChecked==true'>
                                         <span slot="tab">
                                            <span class="fa fa-mobile" />
                                            PDT Wavelet
                                        </span>
                                        <div class="col-12 mt-2 mx-0 my-0">
                                            <h6 class="heading-small text-muted">Path</h6>
                                            <a-input v-model='pdtSourcePath' placeholder="App Path" :disabled='true'/>

                                            <h6 class="heading-small text-muted">Price</h6>
                                            <a-input v-model='pdtWaveletPrice' placeholder="Price" :disabled='true'/>
                                        </div>
                                    </a-tab-pane>
                                </a-tabs>
                            </div>
                            <div v-if="current == 1 && prevAppId > 0" class="col mt-2 steps-content" style="max-height: 80vh; overflow: auto;">
                                <br/>
                                <small>Configure app update below: </small>
                                <br/><br/>
                                <div class="row no-gutters">
                                    <!-- ACCOUNTS  -->
                                    <div class="col-md-4" style="border-left: 1px solid #e0e0e0;  border-right: 1px solid #e0e0e0; height: 100vh;">
                                        <div class="list-group-item" style="border-radius: 0px; font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                            <div class="row">
                                                <div class="col-md-6">Accounts</div>
                                                <div class="col-md-6 float-right">
                                                    <base-button class="float-right ml-1" type="primary" size="sm" @click="openDrawer('a')"><span class="fa fa-plus" /></base-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="accounts.length > 0">
                                            <!-- :class="[{selected2: selectedAccount.id == account.id}]" -->
                                            <div v-if="selectedAccount != null">
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(account, index) in accounts" :key="index" :class="[{selected2: selectedAccount.id == account.id}]">
                                                    <div class="row" @click="setAccount(account)">
                                                       <div class="col-md-8">{{account.account_name}}</div>
                                                       <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                    </div>
                                                 </div>
                                            </div>
                                            <div v-else>
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(account, index) in accounts" :key="index">
                                                    <div class="row" @click="setAccount(account)">
                                                       <div class="col-md-8">{{account.account_name}}</div>
                                                       <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                    </div>
                                                 </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                           <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                               <span slot="description"> Please add accounts on the list. </span>
                                           </a-empty>
                                        </div>
                                    </div>

                                    <!-- SITES  -->
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                                        <div class="list-group-item" style="border-radius: 0px; font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                            <div class="row">
                                                <div class="col-md-6">Sites</div>
                                                <div class="col-md-6 float-right">
                                                    <base-button :disabled="selectedAccount == null" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('s')"><span class="fa fa-plus" /></base-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="siteIds.length > 0">
                                            <div v-if="selectedSite != null">
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(site, index) in siteList" :key="index" :class="[{selected2: selectedSite.id == site.id}]">
                                                    <div class="row" @click="setSite(site)">
                                                       <div class="col-md-8">{{site.name}}</div>
                                                       <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(site, index) in siteList" :key="index">
                                                    <div class="row" @click="setSite(site)">
                                                       <div class="col-md-8">{{site.name}}</div>
                                                       <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-else>
                                           <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                               <span slot="description"> Please select an account and select sites. </span>
                                           </a-empty>
                                        </div>
                                    </div>

                                    <!-- DEVICES  -->
                                    <div class="col-md-4" style="border-right: 1px solid #e0e0e0; height: 100vh;">
                                        <div class="list-group-item" style="border-radius: 0px; font-size: 14px; height: 55px; background-color: #f7f7f7;">
                                            <div class="row">
                                                <div class="col-md-6">Devices</div>
                                                <div class="col-md-6 float-right">
                                                    <base-button :disabled="selectedSite == null" class="float-right ml-1" type="primary" size="sm" @click="openDrawer('d')"><span class="fa fa-plus" /></base-button>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="deviceIds.length > 0">
                                            <div class="list-group-item" style="font-size: 14px; border-radius: 0px;" v-for="(device, index) in deviceList" :key="index">
                                                <div class="row">
                                                   <div class="col-md-8">{{device.name}}</div>
                                                   <!-- <div class="col-md-4"><span class="ni ni-bold-right float-right" style="padding-bottom: 5px"/></div> -->
                                                </div>
                                             </div>
                                        </div>
                                        <div v-else>
                                           <a-empty class='mt-5' :image-style="{height: '50px',}" >
                                               <span slot="description"> Please select a site on the list. </span>
                                           </a-empty>
                                        </div>
                                    </div>

                                </div>
                            </div>
                            <div v-if="current == 2" class="col mt-2 steps-content" style="max-height: 80vh; overflow: auto;">
                                <div v-if='isNewVersion==true' class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">Version</h6>
                                    <a-input-number style="width: 100%" v-model='waveletVersion' placeholder="Version" :disabled="mode=='open_wavelet'"/>
                                </div>
                                <a-tabs :default-active-key="tabDefaultActiveKey">
                                    <a-tab-pane :key="1" v-if='webUploadChecked==true'>
                                        <span slot="tab">
                                        <a-icon type="laptop" />
                                            Web Wavelet
                                        </span>
                                        <a-collapse v-model="webActiveKey">
                                            <a-collapse-panel key="1" header="Information">
                                                <div class="col-12 mt-2 mx-0 my-0">
                                                    <h6 class="heading-small text-muted">Name</h6>
                                                    <a-input v-model='webWaveletJson.name' placeholder="Name" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Author</h6>
                                                    <a-input v-model='webWaveletJson.author' placeholder="Author" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Company</h6>
                                                    <a-input v-model='webWaveletJson.company' placeholder="Company" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Definition</h6>
                                                    <a-input v-model='webWaveletJson.definition' placeholder="Definition" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Redirect Link</h6>
                                                    <a-input v-model='webWaveletJson.redirect_link' placeholder="Redirect Link" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Logo</h6>
                                                    <a-input v-model='webWaveletJson.logo' placeholder="Logo" :disabled='true'/>
                                                </div>
                                                <div v-if='webWaveletJson.tags!=undefined' class="col-12 mt-3">
                                                    <strong class="strong heading-small text-muted mr-2">Tags</strong>
                                                    <a-tag v-for="tags in webWaveletJson.tags.split(',')" :key="tags" color="geekblue">
                                                        {{tags}}
                                                    </a-tag>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="2" header="Permissions" >
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Profile</th>
                                                                <th scope="col">Methods</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, profile) in webWaveletJson.permissions">
                                                                <td>{{profile}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="methods"'>{{value.join(', ')}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="3" header="Modules">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Settings</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in webWaveletJson.modules">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="status"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="settings"'>
                                                                        <button class='btn btn-sm btn-info' type="primary" @click='showSettingDrawer(value)'>View</button>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                        </a-collapse>
                                    </a-tab-pane>
                                    <a-tab-pane :key="2" v-if='posUploadChecked==true'>
                                        <span slot="tab">
                                            <a-icon type="cluster" />
                                            POS Wavelet
                                        </span>
                                        <a-collapse v-model="posActiveKey">
                                            <a-collapse-panel key="4" header="Information">
                                                <div class="col-12 mt-2 mx-0 my-0">
                                                    <h6 class="heading-small text-muted">Name</h6>
                                                    <a-input v-model='posWaveletJson.name' placeholder="Name" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Author</h6>
                                                    <a-input v-model='posWaveletJson.author' placeholder="Author" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Company</h6>
                                                    <a-input v-model='posWaveletJson.company' placeholder="Company" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Version</h6>
                                                    <a-input v-model='posWaveletJson.version' placeholder="Version" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Definition</h6>
                                                    <a-input v-model='posWaveletJson.definition' placeholder="Definition" :disabled='true'/>
                                                </div>
                                                <div class="col-12 mt-2">
                                                    <h6 class="heading-small text-muted">Logo</h6>
                                                    <a-input v-model='posWaveletJson.logo' placeholder="Logo" :disabled='true'/>
                                                </div>
                                                <div v-if='posWaveletJson.tags!=undefined' class="col-12 mt-3">
                                                    <strong class="strong heading-small text-muted mr-2">Tags</strong>
                                                    <a-tag v-for="tags in posWaveletJson.tags.split(',')" :key="tags" color="geekblue">
                                                        {{tags}}
                                                    </a-tag>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="5" header="Permissions">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Profile</th>
                                                                <th scope="col">Methods</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, profile) in posWaveletJson.permissions">
                                                                <td>{{profile}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="methods"'>{{value.join(', ')}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="6" header="Events">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Function Name</th>
                                                                <th scope="col">Priority</th>
                                                                <th scope="col">Blocking</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in posWaveletJson.events">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="functionName"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="priority"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="blocking"'>{{value}}</td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                            <a-collapse-panel key="7" header="Modules">
                                                <div class="table-responsive">
                                                    <table class="table table-bordered table-sm">
                                                        <thead>
                                                            <tr>
                                                                <th scope="col">Name</th>
                                                                <th scope="col">Status</th>
                                                                <th scope="col">Settings</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(values, name) in posWaveletJson.modules">
                                                                <td>{{name}}</td>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="status"'>{{value}}</td>
                                                                </template>
                                                                <template v-for="(value, data) in values">
                                                                    <td v-if='data=="settings"'>
                                                                        <button class='btn btn-sm btn-info' type="primary" @click='showSettingDrawer(value)'>View</button>
                                                                    </td>
                                                                </template>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </a-collapse-panel>
                                        </a-collapse>
                                    </a-tab-pane>
                                    <a-tab-pane :key="3" v-if='appUploadChecked==true'>
                                         <span slot="tab">
                                            <span class="fa fa-mobile" />
                                            App Wavelet
                                        </span>
                                        <div class="col-12 mt-2 mx-0 my-0">
                                            <h6 class="heading-small text-muted">Path</h6>
                                            <a-input v-model='appSourcePath' placeholder="App Path" :disabled='true'/>

                                            <h6 class="heading-small text-muted">Price</h6>
                                            <a-input v-model='appWaveletPrice' placeholder="Price" :disabled='true'/>
                                        </div>
                                    </a-tab-pane>
                                </a-tabs>
                            </div>

                        </div>
                        <div v-else-if='mode=="create_wavelet" || mode=="open_wavelet"' class="card-body">
                            <div class="row">
                                <h3 v-if="mode!='open_wavelet'" class="col card-title">{{ _.startCase(mode)}}</h3>
                                <h3 v-else class="col card-title">View Wavelet</h3>

                                <div v-if="mode=='create_wavelet'" class="col">
                                    <button v-if="!isRippleAdmin" class='float-right mx-1 btn btn-sm btn-success' type="primary" @click='createWavelet()'>Create Wavelet</button>
                                </div>
                                <div v-else class="col">
                                    <base-dropdown class="nav-link px-0 float-right" position="right">
                                        <div class="media align-items-center" slot="title">
                                        <i class="fa fa-ellipsis-v float-right ml-2 btn-sm" style='color: black;'></i>
                                        </div>
                                        <template>
                                            <div class="dropdown-header noti-title">
                                                <h6 class="text-overflow m-0">ACTIONS</h6>
                                            </div>
                                            <a class="dropdown-item" @click='deleteWavelet(waveletId)'><i class="fas fa-trash"></i><span>Delete</span></a>
                                            <a class="dropdown-item" v-if='!isRippleAdmin && waveletStatus=="L"' @click="newVersion(waveletId, waveletName, waveletDescription, waveletVersion)"><i class="fas fa-file-import"></i><span>New Version</span></a>
                                        </template>
                                    </base-dropdown>

                                    <button v-if="!isRippleAdmin" class='float-right mx-1 btn btn-sm btn-success' type="primary" @click='updateWavelet(waveletId)'>Update</button>

                                    <button v-if="isRippleAdmin && waveletStatus == 'P'" class='float-right mx-1 btn btn-sm btn-success' type="primary" @click="approveWavelet(waveletId)">Approve</button>
                                    <!-- <button class='float-right mx-1 btn btn-sm btn-info' type="primary" @click="configure('configuration')" v-if="waveletIsMobile != true"> -->
                                    <button class='float-right mx-1 btn btn-sm btn-info' type="primary" @click="configure('configuration')" >
                                        <span v-if="!isRippleAdmin">Configuration</span>
                                        <span v-else>Review Configuration</span>
                                    </button>

                                </div>
                            </div>
                            <hr class="my-2">
                            <div class="row">
                                <!-- <div class="col-12 mt-2">
                                    <a-switch :disabled="mode=='open_wavelet'" class="float-right" checked-children="Mobile" un-checked-children="Mobile" v-model="waveletIsMobile"/>
                                </div>  -->
                                <div class="col-12 mt-2 " >
                                    <div class="row">
                                        <h6 class="col-6 heading-small text-muted">Name</h6>
                                        <div class="col-6">
                                            <a-tag class='float-right' v-if="waveletStatus == 'O'" color="orange">Development</a-tag>
                                            <a-tag class='float-right' v-if="waveletStatus == 'D'" color="red">Deleted</a-tag>
                                            <a-tag class='float-right' v-if="waveletStatus == 'P'" color="red">For Approval</a-tag>
                                            <a-tag class='float-right' v-if="waveletStatus == 'L'" color="green">Live</a-tag>
                                        </div>
                                    </div>
                                    <a-input v-model='waveletName' placeholder="Name" :maxLength='255' :disabled='isRippleAdmin'/>
                                </div>
                                <div class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">Description</h6>
                                    <a-textarea v-model='waveletDescription' placeholder="Description" :disabled='isRippleAdmin' :auto-size="{ minRows: 4, maxRows: 5 }" :maxLength='8000'/>
                                </div>
                                <div class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">Version</h6>
                                    <a-input-number style="width: 100%" v-model='waveletVersion' placeholder="Version" :disabled="mode=='open_wavelet'"/>
                                </div>
                                <div v-if="mode=='open_wavelet'" class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">App Key</h6>
                                    <a-input v-model='waveletAppKey' placeholder="App Key" :disabled="mode=='open_wavelet'">
                                    <a-icon v-clipboard:copy="waveletAppKey" v-clipboard:success="onClipboardCopy" v-clipboard:error="onClipboardError" slot="addonBefore" class='mb-1' type="copy" />
                                    </a-input>
                                </div>
                                <div v-if="mode=='open_wavelet'" class="col-12 mt-2">
                                    <h6 class="heading-small text-muted">App Secret</h6>
                                    <a-input v-model='waveletAppSecret' :type='secretFieldType' placeholder="App Secret" :disabled="mode=='open_wavelet'">
                                        <a-icon @click='appKeySwitchVisibility' slot="addonAfter" class='mb-1' :type="appKeyVisibilityIcon" />
                                        <a-icon v-if='appKeyVisibilityIcon!="eye"' v-clipboard:copy="waveletAppSecret" v-clipboard:success="onClipboardCopy" v-clipboard:error="onClipboardError" slot="addonBefore" class='mb-1' type="copy" />
                                    </a-input>
                                </div>
                            </div>
                        </div>
                        <div v-else class="card-body">
                            <a-empty class='mt-5' :image-style="{height: '50px',}" >
                            <span slot="description"> Please select a wavelet </span>
                            </a-empty>
                        </div>
                    </div>
                </div>
            </div>

            <a-drawer
                title="Settings"
                :width="480"
                placement="right"
                :visible="settingDrawerVisible"
                @close="onSettingDrawerClose"
            >
                <vue-json-pretty
                    :data="jsonSetting">
                </vue-json-pretty>
            </a-drawer>
    </div>

</template>


<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import ValidateField from '../../components/validateFormUtils.js';
    import axios from "axios";
    import { mapState, mapActions } from 'vuex'
    import VueJsonPretty from 'vue-json-pretty'
    var component_x;

    export default {
        components:{
            VueJsonPretty
        },
        mounted: async function(){
            component_x = this;
            await HTTPRequest.postRequest(component_x.endPoint + 'users/create_user_act', null, {controller:"/BXI Apps",category:"Wavelets",system_module:"BXI Apps",actions:"View"})
            this.retrieveWavelets();
        },
        computed: {
            ...mapState(['endPoint']),
        },
        filters: {
            truncate: function (text, length, suffix) {
                if (text.length > length){
                    return text.substring(0, length) + suffix;
                }else {
                    return text
                }

            },
        },
        data() {
          return {
            waveletColumns: [{scopedSlots: { customRender: 'info' }},{scopedSlots: { customRender: 'action' }}],
            steps: [{title: 'Upload'},{title: 'Review'}],

            accounts: [],
            selectedAccount: null,
            selectedSite: null,
            accountIds: [],
            drawerVisible: false,
            accountOptions: [],
            fetching: false,
            type: 'a',
            siteOptions: [],
            siteList: [],
            siteIds: [],
            deviceOptions: [],
            deviceIds: [],
            deviceIdsDup: [],
            deviceList: [],
            activeAccounts: {},
            // steps2:  [{title: 'Upload'},{title: 'App Update Settings'}, {title: 'Review'}],

            developerMode: secureStorage.getItem("developerMode"),
            developerEmail: secureStorage.getItem("developerEmail"),
            developerAccountId: secureStorage.getItem("developerAccountId"),
            userName: secureStorage.getItem("userName"),
            isRippleAdmin: secureStorage.getItem("isRippleAdmin"),
            mode: '',
            current: 0,
            settingDrawerVisible: false,
            jsonSetting: {},

            wavelets: [],
            waveletId: null,
            waveletName: null,
            waveletDescription: null,
            waveletStatus: null,
            waveletAppKey: null,
            waveletAppSecret: null,
            secretFieldType: 'password',
            appKeyVisibilityIcon: 'eye',
            waveletVersion: null,
            waveletIsMobile: false,
            waveletPreviousVersion: null,

            webUploadChecked: false,
            posUploadChecked: false,
            appUploadChecked: false,
            pdtUploadChecked: false,

            webWaveletList: [],
            webWaveletTxtList: [],
            webWaveletJson: null,
            webWaveletPrice: null,
            webWaveletId: null,
            webWaveletTextFiles: [],
            webFile1: null,
            webFile2: null,

            posWaveletList: [],
            posWaveletTxtList: [],
            posWaveletJson: null,
            posWaveletPrice: null,
            posWaveletId: null,
            posWaveletTextFiles: [],
            posFile1: null,
            posFile2: null,
            posSourcePath: null,

            appWaveletId: null,
            appWaveletList: [],
            appWaveletPrice: null,
            appSourcePath: null,
            appFile1: null,
            appSourcePath: null,
            prevAppId: 0,

            // PDT
            pdtWaveletId: null,
            pdtWaveletList: [],
            pdtWaveletPrice: null,
            pdtSourcePath: null,
            pdtFile1: null,
            prevPdtId: 0,

            webActiveKey: 1,
            posActiveKey: 4,
            tabDefaultActiveKey: 1,

            isNewVersion: false,
            waveletFilterStatus: '0',
          }
        },
        methods: {
            handleRemoveWebText(file) {
                const index = this.webWaveletTextFiles.indexOf(file);
                const newFileList = this.webWaveletTextFiles.slice();
                newFileList.splice(index, 1);
                this.webWaveletTextFiles = newFileList;
            },
            beforeUploadWebText(file) {
                this.webWaveletTextFiles = [...this.webWaveletTextFiles, file];
                return false;
            },
            async onSearch(value){
                this.retrieveWavelets(this.waveletFilterStatus, value)
            },
            async handleChangeWebText(file){
                var latestUpload = this.webWaveletTextFiles[this.webWaveletTextFiles.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "txt"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .txt files only."
                        });
                        this.handleRemoveWebText(file)
                    }  else {
                        if(this.webWaveletTextFiles.length > 2)
                            this.handleRemoveWebText(this.webWaveletTextFiles[0])
                    }
                }
            },

            handleRemovePosText(file) {
                const index = this.posWaveletTextFiles.indexOf(file);
                const newFileList = this.posWaveletTextFiles.slice();
                newFileList.splice(index, 1);
                this.posWaveletTextFiles = newFileList;
            },
            beforeUploadPosText(file) {
                this.posWaveletTextFiles = [...this.posWaveletTextFiles, file];
                return false;
            },
            async handleChangePosText(file){
                var latestUpload = this.posWaveletTextFiles[this.posWaveletTextFiles.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "txt"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .txt files only."
                        });
                        this.handleRemovePosText(file)
                    }  else {
                        if(this.posWaveletTextFiles.length > 2)
                            this.handleRemovePosText(this.posWaveletTextFiles[0])
                    }
                }
            },

            handleRemoveWeb(file) {
                const index = this.webWaveletList.indexOf(file);
                const newFileList = this.webWaveletList.slice();
                newFileList.splice(index, 1);
                this.webWaveletList = newFileList;
            },
            beforeUploadWeb(file) {
                this.webWaveletList = [...this.webWaveletList, file];
                return false;
            },
            async handleChangeWeb(file){
                var latestUpload = this.webWaveletList[this.webWaveletList.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "wvl"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .wvl files only."
                        });
                        this.handleRemoveWeb(file)
                    }  else {
                        if(this.webWaveletList.length > 1)
                            this.handleRemoveWeb(this.webWaveletList[0])
                    }
                }

                //Get .wvl json data
                const reader = new FileReader();
                reader.readAsText(file.file);
                const result = await new Promise((resolve, reject) => {
                    reader.onload = function(event) {
                    resolve(reader.result)
                    }
                })
                this.webWaveletJson = JSON.parse(result)
            },
            webCheckboxToggle(val){
                this.webUploadChecked = val.target.checked
                if (this.webUploadChecked == false){
                    this.webWaveletList = []
                    this.webWaveletJson = null
                    this.webWaveletPrice = null
                    this.webWaveletTextFiles = []
                    this.webFile1 = null
                    this.webFile2 = null
                }
            },

            handleRemovePos(file) {
                const index = this.posWaveletList.indexOf(file);
                const newFileList = this.posWaveletList.slice();
                newFileList.splice(index, 1);
                this.posWaveletList = newFileList;
            },
            beforeUploadPos(file) {
                this.posWaveletList = [...this.posWaveletList, file];
                return false;
            },
            async handleChangePos(file){
                var latestUpload = this.posWaveletList[this.posWaveletList.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "zip"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .zip files only."
                        });
                        this.handleRemovePos(file)
                    }  else {
                        if(this.posWaveletList.length > 1)
                            this.handleRemovePos(this.posWaveletList[0])
                    }
                }
                var pos_wvl_json = null;
                var pos_source_path = null;
                var bodyFormData = new FormData();
                bodyFormData.append('pos_zip', this.posWaveletList[0])
                await axios({
                    method: 'post',
                    url: component_x.endPoint + "/pos_wavelets/upload_zip?wavelet_id="+this.waveletId,
                    data: bodyFormData,
                    headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                })
                .then(async function (response) {
                    pos_wvl_json = await HTTPRequest.getRequest(component_x.endPoint + 'pos_wavelets/get_zip_wvl?zip_file='+response.data, null)
                    pos_source_path = response.data
                })
                this.posWaveletJson = pos_wvl_json
                this.posSourcePath = pos_source_path
            },
            posCheckboxToggle(val){
                this.posUploadChecked = val.target.checked
                if (this.posUploadChecked == false){
                    this.posWaveletList = []
                    this.posWaveletJson = null
                    this.posWaveletPrice = null
                    this.posWaveletTextFiles = []
                    this.posFile1 = null
                    this.posFile2 = null
                }
            },

            // APP
            handleRemoveApp(file) {
                const index = this.appWaveletList.indexOf(file);
                const newFileList = this.appWaveletList.slice();
                newFileList.splice(index, 1);
                this.appWaveletList = newFileList;
            },
            // PDT
            handleRemovePdt(file) {
                const index = this.pdtWaveletList.indexOf(file);
                const newFileList = this.pdtWaveletList.slice();
                newFileList.splice(index, 1);
                this.pdtWaveletList = newFileList;
            },
            // PDT
            beforeUploadPdt(file) {
                this.pdtWaveletList = [...this.pdtWaveletList, file];
                console.log(this.pdtWaveletList)
                return false;
            },

            beforeUploadApp(file) {
                this.appWaveletList = [...this.appWaveletList, file];
                return false;
            },
            async handleChangeApp(file){
                console.log("I AM HERE")
                var latestUpload = this.appWaveletList[this.appWaveletList.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "zip"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .zip files only."
                        });
                        this.handleRemoveApp(file)
                    }  else {
                        if(this.appWaveletList.length > 1)
                            this.handleRemoveApp(this.appWaveletList[0])
                    }
                }
                // var pos_wvl_json = null;
                var app_source_path = null;
                var bodyFormData = new FormData();
                bodyFormData.append('app_zip', this.appWaveletList[0])
                await axios({
                    method: 'post',
                    url: component_x.endPoint + "/app_wavelets/upload_zip?wavelet_id="+this.waveletId,
                    data: bodyFormData,
                    headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                })
                .then(async function (response) {
                    // NO WVL FOR APPS
                    // pos_wvl_json = await HTTPRequest.getRequest(component_x.endPoint + 'pos_wavelets/get_zip_wvl?zip_file='+response.data, null)
                    app_source_path = response.data
                    console.log(app_source_path)
                    component_x.appSourcePath = app_source_path
                })
                // this.posWaveletJson = pos_wvl_json

            },

            //PDT
            async handleChangePdt(file){
                console.log("I AM HERE PDT")
                var latestUpload = this.pdtWaveletList[this.pdtWaveletList.length - 1]
                if (latestUpload != undefined) {
                    var fileExtension = latestUpload.name.split(".").pop()
                    if(fileExtension != "apk"){
                        this.$notification['error']({
                            message: 'Unsupported file type',
                            description: "Upload .apk files only."
                        });
                        this.handleRemovePdt(file)
                    }  else {
                        if(this.pdtWaveletList.length > 1)
                            this.handleRemovePdt(this.pdtWaveletList[0])
                    }
                }
                // var pos_wvl_json = null;
                var pdt_source_path = null;
                var bodyFormData = new FormData();
                console.log(this.pdtWaveletList[0])
                bodyFormData.append('app_apk', this.pdtWaveletList[0])
                await axios({
                    method: 'post',
                    url: component_x.endPoint + "/app_wavelets/upload_apk?wavelet_id="+this.waveletId,
                    data: bodyFormData,
                    headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                })
                .then(async function (response) {
                    // NO WVL FOR APPS
                    // pos_wvl_json = await HTTPRequest.getRequest(component_x.endPoint + 'pos_wavelets/get_zip_wvl?zip_file='+response.data, null)
                    pdt_source_path = response.data
                    console.log(pdt_source_path)
                    component_x.pdtSourcePath = pdt_source_path
                })
                // this.posWaveletJson = pos_wvl_json

            },

            appCheckboxToggle(val){
                this.appUploadChecked = val.target.checked
                if (this.appUploadChecked == false){
                    // this.posWaveletList = []
                    // this.posWaveletJson = null
                    // this.posWaveletPrice = null
                    // this.posWaveletTextFiles = []
                    // this.posFile1 = null
                    // this.posFile2 = null
                }
            },

            pdtCheckboxToggle(val){
                this.pdtUploadChecked = val.target.checked
            },

            submitWavelets() {
                var inputErrors = []

                if (this.webUploadChecked == false && this.posUploadChecked == false && this.appUploadChecked == false && this.pdtUploadChecked == false) {
                    inputErrors.push('Atleast one wavelet file is required')
                } else {
                    if (this.webUploadChecked == true) {
                        inputErrors.push(ValidateField.required('Web Wavelet', this.webWaveletJson, "Web wavelet is required / format is incorrect"))
                        inputErrors.push(ValidateField.positiveNumber('Web Wavelet Price', this.webWaveletPrice))
                    }
                    if (this.posUploadChecked == true) {
                        inputErrors.push(ValidateField.required('POS Wavelet', this.posWaveletJson, "POS wavelet is required / format is incorrect"))
                        inputErrors.push(ValidateField.positiveNumber('POS Wavelet Price', this.posWaveletPrice))
                    }

                    if (this.appUploadChecked == true) {
                        inputErrors.push(ValidateField.positiveNumber('App Wavelet Price', this.appWaveletPrice))
                    }

                    if (this.pdtUploadChecked == true) {
                        inputErrors.push(ValidateField.positiveNumber('PDT Wavelet Price', this.pdtWaveletPrice))
                    }
                }

                inputErrors = _.compact(inputErrors)
                if (inputErrors.length > 0) {
                    this.notification('error', 'submitting', inputErrors)
                } else {
                    this.tabDefaultActiveKey = this.webUploadChecked ? 1 : 2;
                    this.current++;
                }
            },
            back() {
                this.current--;
            },
            configure(mode){
                this.mode = mode
            },
            changeMode(mode){
                this.mode = mode
                this.waveletId = null
                this.waveletName = null
                this.waveletDescription = null
                this.waveletStatus = null
                this.waveletAppKey = null
                this.waveletAppSecret = null
                this.waveletVersion = null
                this.waveletIsMobile = false
                this.waveletPreviousVersion = null

                this.webUploadChecked = false
                this.webWaveletList = []
                this.webWaveletTxtList = []
                this.webWaveletJson = null
                this.webWaveletPrice = null
                this.webWaveletId = null
                this.webWaveletTextFiles = []
                this.webFile1 = null
                this.webFile2 = null

                this.posUploadChecked = false
                this.posWaveletList = []
                this.posWaveletTxtList = []
                this.posWaveletJson = null
                this.posWaveletPrice = null
                this.posWaveletId = null
                this.posWaveletTextFiles = []
                this.posFile1 = null
                this.posFile2 = null

            },
            notification(action, msg, errors){
                if (action=='success') {
                    this.$notification['success']({
                        message: 'Wavelet',
                        description: "Success "+msg+" wavelet"
                    });
                }else {
                    this.$notification['error']({
                        message: 'Wavelet processing failed',
                        description: h => {
                            return <ul class='m-0 p-0'>
                                {errors.map((value, index) => {
                                    return <li key={index}>{value}</li>
                                })}
                            </ul>
                        }
                    });
                }
            },
            async retrieveWavelets(status, search){
                var wavelets = []
                let url = 'wavelets?'
                if (!this.isRippleAdmin) {
                    url += '&developer_account_id='+this.developerAccountId
                }
                if (!(status == undefined || status == '0')){
                    url += '&status='+status
                }
                if (search != undefined){
                    url += '&name='+search
                }

                wavelets = await HTTPRequest.getRequest(component_x.endPoint + url, null)
                this.wavelets = wavelets.data
            },
            async createWavelet(){
                var inputErrors = []
                inputErrors.push(ValidateField.required('Name', this.waveletName))
                inputErrors.push(ValidateField.required('Description', this.waveletDescription))
                inputErrors.push(ValidateField.required('Version', this.waveletVersion))
                inputErrors = _.compact(inputErrors)
                if (inputErrors.length > 0) {
                    this.notification('error', 'creating', inputErrors)
                } else {
                    // if(this.waveletIsMobile == true){
                    //     var wavelet_payload = {developer_account_id: this.developerAccountId, name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, created_by: this.developerEmail, updated_by: this.developerEmail, is_mobile: this.waveletIsMobile}
                    // } else {
                    //     var wavelet_payload = {developer_account_id: this.developerAccountId, name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, created_by: this.developerEmail, updated_by: this.developerEmail, is_mobile: this.waveletIsMobile}
                    // }
                    // var wavelet_payload = {developer_account_id: this.developerAccountId, name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, created_by: this.developerEmail, updated_by: this.developerEmail, is_mobile: this.waveletIsMobile}
                    var wavelet_payload = {developer_account_id: this.developerAccountId, name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, created_by: this.developerEmail, updated_by: this.developerEmail}
                    var wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'wavelets', null, wavelet_payload)
                    if (wavelet.id > 0) {
                        this.notification('success', 'creating')
                        this.retrieveWavelets();
                        this.openWavelet(wavelet.id)
                    }
                }
            },
            async updateWavelet(wavelet_id){
                var inputErrors = []
                inputErrors.push(ValidateField.required('Name', this.waveletName))
                inputErrors.push(ValidateField.required('Description', this.waveletDescription))
                inputErrors.push(ValidateField.required('Description', this.waveletVersion))
                inputErrors = _.compact(inputErrors)
                if (inputErrors.length > 0) {
                    this.notification('error', 'updating', inputErrors)
                } else {
                    var wavelet_payload = {name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, updated_by: this.developerEmail}
                    var wavelet = await HTTPRequest.putRequest(component_x.endPoint + 'wavelets/'+wavelet_id, null, wavelet_payload)
                    if (wavelet.id > 0) {
                        this.notification('success', 'updating')

                        this.retrieveWavelets();
                        this.openWavelet(wavelet.id)
                    }
                }
            },
            async deleteWavelet(wavelet_id){
                var wavelet_payload = {name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, deleted_by: this.developerEmail}
                var wavelet = await HTTPRequest.destroyRequest(component_x.endPoint + 'wavelets/'+wavelet_id, null, wavelet_payload)
                if (wavelet.status == "D") {
                    this.notification('success', 'destroying')

                    this.retrieveWavelets();
                    this.mode = ''
                }
            },
            async openWavelet(wavelet_id){
                this.mode = 'open_wavelet'
                var wavelet = await HTTPRequest.getRequest(component_x.endPoint + 'wavelets/'+wavelet_id, null)
                console.log(wavelet)
                this.waveletId = wavelet.id
                this.waveletName = wavelet.name
                this.waveletDescription = wavelet.description
                this.waveletStatus = wavelet.status
                this.waveletAppKey = wavelet.app_key
                this.waveletAppSecret = wavelet.app_secret
                this.waveletVersion = wavelet.version
                // this.waveletIsMobile = wavelet.is_mobile
                this.waveletPreviousVersion = wavelet.version

                if (wavelet.web_wavelet != null) {
                    this.webUploadChecked = true
                    this.webWaveletJson = wavelet.web_wavelet.default_configuration
                    this.webWaveletPrice = wavelet.web_wavelet.price
                    this.webWaveletId = wavelet.web_wavelet.id
                    this.webWaveletTextFiles = []
                    this.webFile1 = (wavelet.web_wavelet.text_file_1 != undefined) ? wavelet.web_wavelet.text_file_1.split('-')[0]+ ".txt" : ""
                    this.webFile2 = (wavelet.web_wavelet.text_file_2 != undefined) ? wavelet.web_wavelet.text_file_2.split('-')[0]+ ".txt" : ""
                } else {
                    this.webUploadChecked = false
                    this.webWaveletList = []
                    this.webWaveletTxtList = []
                    this.webWaveletJson = null
                    this.webWaveletPrice = null
                    this.webWaveletId = null
                    this.webWaveletTextFiles = []
                    this.webFile1 = null
                    this.webFile2 = null
                }

                if (wavelet.pos_wavelet != null) {
                    this.posUploadChecked = true
                    this.posWaveletJson = wavelet.pos_wavelet.configuration
                    this.posWaveletPrice = wavelet.pos_wavelet.price
                    this.posWaveletId = wavelet.pos_wavelet.id
                    this.posWaveletTextFiles = []
                    this.posFile1 = (wavelet.pos_wavelet.text_file_1 != undefined) ? wavelet.pos_wavelet.text_file_1.split('-')[0]+ ".txt" : ""
                    this.posFile2 = (wavelet.pos_wavelet.text_file_2 != undefined) ? wavelet.pos_wavelet.text_file_2.split('-')[0]+ ".txt" : ""
                } else {
                    this.posUploadChecked = false
                    this.posWaveletList = []
                    this.posWaveletTxtList = []
                    this.posWaveletJson = null
                    this.posWaveletPrice = null
                    this.posWaveletTextFiles = []
                    this.posWaveletId = null
                    this.posFile1 = null
                    this.posFile2 = null
                }

                if (wavelet.app_wavelet != null) {
                    var strcount = (wavelet.app_wavelet['source_path']).length

                    if((wavelet.app_wavelet['source_path']).substring(strcount - 3, strcount) == 'apk'){

                        this.pdtUploadChecked = true
                        this.pdtWaveletPrice = wavelet.pdt_wavelet.price
                        this.pdtWaveletId = wavelet.pdt_wavelet.id
                        this.pdtSourcePath = wavelet.pdt_wavelet.source_path

                        this.appUploadChecked = false
                        this.appWaveletList = []
                        this.appWaveletPrice = null

                    } else {
                        this.appUploadChecked = true
                        this.appWaveletPrice = wavelet.app_wavelet.price
                        this.appWaveletId = wavelet.app_wavelet.id
                        this.appSourcePath = wavelet.app_wavelet.source_path
                        this.pdtUploadChecked = false
                        this.pdtWaveletList = []
                        this.pdtWaveletPrice = null
                    }

                } else {
                    this.appUploadChecked = false
                    this.appWaveletList = []
                    this.appWaveletPrice = null
                    this.pdtUploadChecked = false
                    this.pdtWaveletList = []
                    this.pdtWaveletPrice = null
                }

                //Set Ant Step to First Step
                this.current = 0;
                this.isNewVersion = false;
            },
            async confirmWavelets(){

                if (this.isNewVersion == true){

                    var inputErrors = []
                    inputErrors.push(ValidateField.isGreaterThan('Version', this.waveletPreviousVersion, this.waveletVersion))
                    inputErrors = _.compact(inputErrors)
                    if (inputErrors.length > 0) {
                        this.notification('error', 'creating', inputErrors)
                    } else {
                        var wavelet_payload = {developer_account_id: this.developerAccountId, name: this.waveletName, description: this.waveletDescription, version: this.waveletVersion, created_by: this.developerEmail, updated_by: this.developerEmail, previous_wavelet_id: this.waveletId, app_key: this.waveletAppKey, app_secret: this.waveletAppSecret, status: "H"}
                        var wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'wavelets', null, wavelet_payload)
                        if (wavelet.id > 0) {
                            console.log("I AM HERE!!!!!!")
                            this.isNewVersion = false
                            this.waveletId = wavelet.id
                            this.confirmWavelets()
                        }
                    }
                } else {

                    console.log("SHOULD UPDATE!!!")
                    var webSuccess = false
                    var posSuccess = false
                    var appSuccess = false
                    var pdtSuccess = false


                    if (this.webUploadChecked == true && this.webWaveletJson != null ) {
                        var web_wavelet_payload = {wavelet_id: this.waveletId, default_configuration: this.webWaveletJson, redirect_link: this.webWaveletJson.redirect_link, price: this.webWaveletPrice, created_by: this.developerEmail, updated_by: this.developerEmail}
                        var web_wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'web_wavelets', null, web_wavelet_payload)
                        if (web_wavelet.id > 0) {
                            var bodyFormData = new FormData();
                            bodyFormData.append('file_1', this.webWaveletTextFiles[0])
                            bodyFormData.append('file_2', this.webWaveletTextFiles[1])
                            await axios({
                                method: 'post',
                                url: component_x.endPoint + "/web_wavelets/" + web_wavelet.id + "/upload_text",
                                data: bodyFormData,
                                headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                            })
                            .then(async function (response) {
                                if (response.data.id > 0) {
                                    webSuccess = true
                                }
                            })
                        }
                    }

                    if (this.posUploadChecked == true && this.posWaveletJson != null) {
                        var pos_wavelet_payload = {wavelet_id: this.waveletId, source_path: this.posSourcePath, configuration: this.posWaveletJson, price: this.posWaveletPrice, created_by: this.developerEmail, updated_by: this.developerEmail}
                        var pos_wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'pos_wavelets', null, pos_wavelet_payload)
                        if (pos_wavelet.id > 0) {
                            var bodyFormData = new FormData();
                            bodyFormData.append('file_1', this.posWaveletTextFiles[0])
                            bodyFormData.append('file_2', this.posWaveletTextFiles[1])
                            await axios({
                                method: 'post',
                                url: component_x.endPoint + "/pos_wavelets/" + pos_wavelet.id + "/upload_text",
                                data: bodyFormData,
                                headers: {Authorization: 'Bearer ' + secureStorage.getItem("accessToken"), "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")},
                            })
                            .then(async function (response) {
                                if (response.data.id > 0) {
                                    posSuccess = true
                                }
                            })
                        }
                    }

                    if (this.appUploadChecked == true) {
                        console.log("UPDATING APP")
                        console.log(this.activeAccounts)
                        var app_wavelet_payload = {configuration: this.activeAccounts, wavelet_id: this.waveletId, source_path: this.appSourcePath, price: this.appWaveletPrice, created_by: this.developerEmail, updated_by: this.developerEmail}
                        var app_wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'app_wavelets', null, app_wavelet_payload)
                        if (app_wavelet.id > 0) {
                            appSuccess = true
                        }
                    }

                    if (this.pdtUploadChecked == true) {
                        console.log("UPDATING APP APK")
                        console.log(this.activeAccounts)
                        var pdt_wavelet_payload = {configuration: this.activeAccounts, wavelet_id: this.waveletId, source_path: this.pdtSourcePath, price: this.pdtWaveletPrice, created_by: this.developerEmail, updated_by: this.developerEmail}
                        var pdt_wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'app_wavelets', null, pdt_wavelet_payload)
                        if (pdt_wavelet.id > 0) {
                            pdtSuccess = true
                        }
                    }

                    if (webSuccess == true || posSuccess == true || appSuccess == true || pdtSuccess == true) {
                        this.notification('success', 'submitting')
                        this.current--;
                        this.retrieveWavelets();
                        this.openWavelet(this.waveletId)
                    }
                }

            },
            async approveWavelet(wavelet_id){
                var wavelet_payload = {approved_by: this.developerEmail}
                var wavelet = await HTTPRequest.postRequest(component_x.endPoint + 'wavelets/'+wavelet_id+'/approve', null, wavelet_payload)
                if (wavelet.id > 0) {
                    this.notification('success', 'approving')
                    this.retrieveWavelets();
                    this.openWavelet(wavelet.id)
                }
                this.$parent.retrieveStatistics();
            },
            appKeySwitchVisibility(){
                this.secretFieldType = this.secretFieldType === 'password' ? 'text' : 'password'
                this.appKeyVisibilityIcon = this.appKeyVisibilityIcon === 'eye' ? 'eye-invisible' : 'eye'
            },
            onClipboardCopy: function (e) {
                this.$message.success('Copied to Clipboard',.5)
            },
            onClipboardError: function (e) {
                this.$message.error('Error saving to clipboard',.5)
            },
            showSettingDrawer(value) {
                this.settingDrawerVisible = true;
                this.jsonSetting = value
            },
            onSettingDrawerClose() {
                this.settingDrawerVisible = false;
            },
            async newVersion(){

                this.isNewVersion = true

                this.webUploadChecked = false
                this.webWaveletList = []
                this.webWaveletTxtList = []
                this.webWaveletJson = null
                this.webWaveletPrice = null
                this.webWaveletId = null
                this.webWaveletTextFiles = []
                this.webFile1 = null
                this.webFile2 = null

                this.posUploadChecked = false
                this.posWaveletList = []
                this.posWaveletTxtList = []
                this.posWaveletJson = null
                this.posWaveletPrice = null
                this.posWaveletId = null
                this.posWaveletTextFiles = []
                this.posFile1 = null
                this.posFile2 = null

                this.prevAppId = this.appWaveletId

                if(this.prevAppId > 0){
                    this.steps = [{title: 'Upload'},{title: 'App Update Settings'}, {title: 'Review'}]
                    var accounts = await HTTPRequest.getRequest(component_x.endPoint + 'app_wavelets/' + this.appWaveletId + "/get_accounts", null, null)
                    this.accountOptions = accounts
                    // this.account
                    // Get accounts where app is installed

                }

                this.appUploadChecked = false
                this.appWaveletList = []
                this.appWaveletId = null
                this.appWaveletPrice= null
                this.appSourcePath = null
                this.appFile1 = null

                // APK
                this.pdtUploadChecked = false
                this.pdtWaveletList = []
                this.pdtWaveletId = null
                this.pdtWaveletPrice= null
                this.pdtSourcePath = null
                this.pdtFile1 = null

                this.configure('configuration')
            },
            async filterStatus(){
                this.retrieveWavelets(this.waveletFilterStatus)
            },

            setAccount(account){
                this.selectedAccount = account
                this.siteOptions = this.selectedAccount.sites
                this.siteIds = Object.keys(this.activeAccounts[this.selectedAccount.id]["sites"]).map(Number)
            },
            async setSite(site){
                this.selectedSite = site;
                this.deviceOptions = []
                this.deviceList = []
                var devices = await HTTPRequest.getRequest(component_x.endPoint + 'devices?account_id=' + this.selectedAccount.id +'&site_id=' + this.selectedSite.id , null, null)
                this.deviceOptions = devices.data
                this.deviceIds = Object.keys(this.activeAccounts[this.selectedAccount.id]["sites"][site.id]["devices"]).map(Number)

            },
            openDrawer(type){
                console.log(type);
                this.type = type;
                this.drawerVisible = true;
            },
            onClose(){
                this.drawerVisible = false;
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            async handleSearch(value){
                this.fetching = true;
                if(this.type == 'a'){
                    var accounts = await HTTPRequest.getRequest(component_x.endPoint + 'app_wavelets/' + this.prevAppId + "/get_accounts", null, null)
                    this.accountOptions = accounts
                }else if(this.tyle == 's'){
                    var sites = await HTTPRequest.getRequest(component_x.endPoint + 'sites?=' + this.selectedAccount.id , null, null)
                    this.siteOptions = sites
                }
                this.fetching = false;
            },
        },
        watch: {
            accountIds: function(){
                this.accounts = []
                // IN LIST
                this.accountOptions.map(x => {
                    if(this.accountIds.includes(x.id)){
                        this.accounts.push(x)
                        if(this.activeAccounts[x.id] == undefined){
                            // console.log("Adding...")
                            this.activeAccounts[x.id] = {name: x.account_name, sites: {}}
                        }
                    }
                })

                // console.log("********1*****");
                // console.log(this.accountIds)
                // console.log( JSON.stringify(this.activeAccounts) );

                // GLOBAL VARIABLE
                var activeAccountIds = Object.keys(this.activeAccounts)
                for(var i =0; i < activeAccountIds.length; i++){
                    var activeAccount = parseInt(activeAccountIds[i]);
                    // console.log(activeAccount);
                    if(!this.accountIds.includes(activeAccount)){
                        // console.log("Deleting...")
                        delete this.activeAccounts[activeAccount];
                    }
                }

                // console.log("*******2******");
                // console.log( JSON.stringify(this.activeAccounts) );

                this.siteIds = []
                this.deviceIds = []
                // this.siteList = []
            },
            siteIds: function(){
                this.siteList = []
                if(this.siteIds.length > 0){
                    this.siteOptions.map(x => {
                        if(this.siteIds.includes(x.id)){
                            this.siteList.push(x)
                            if(this.activeAccounts[x.account_id]["sites"][x.id] == undefined){
                                this.activeAccounts[x.account_id]["sites"][x.id] = {name: x.name, devices: {}}
                            }
                        }
                    })

                    var activeSiteIds = Object.keys(this.activeAccounts[this.selectedAccount.id]["sites"])
                    for(var i =0; i < activeSiteIds.length; i++){
                        var activeSite = parseInt(activeSiteIds[i]);
                        // console.log(activeAccount);
                        if(!this.siteIds.includes(activeSite)){
                            // console.log("Deleting...")
                            delete this.activeAccounts[this.selectedAccount.id]["sites"][activeSite];
                        }
                    }

                    console.log("*******SITES******");
                    console.log( JSON.stringify(this.activeAccounts) );

                    this.deviceIds = []

                }


            },
            deviceIds: function(){
                this.deviceList = []
                if(this.deviceIds.length > 0){
                    this.deviceOptions.map(x => {
                        if(this.deviceIds.includes(x.id)){
                            this.deviceList.push(x);
                            if(this.activeAccounts[x.account_id]["sites"][x.site_id]["devices"][x.id] == undefined){
                                this.activeAccounts[x.account_id]["sites"][x.site_id]["devices"][x.id] = {name: x.name}
                            }
                        }
                    })


                    var activeDeviceIds = Object.keys(this.activeAccounts[this.selectedAccount.id]["sites"][this.selectedSite.id]["devices"])
                    for(var i =0; i < activeDeviceIds.length; i++){
                        var activeDevice = parseInt(activeDeviceIds[i]);
                        // console.log(activeAccount);
                        if(!this.deviceIds.includes(activeDevice)){
                            // console.log("Deleting...")
                            delete this.activeAccounts[this.selectedAccount.id]["sites"][this.selectedSite.id]["devices"][activeDevice];
                        }
                    }

                    console.log("*******DEVICE******");
                    console.log( JSON.stringify(this.activeAccounts) );

                }
            },
        }
    }
</script>

<style>
.ant-steps-item-process .ant-steps-item-icon {
    background: #65CB8F;
    border: #65CB8F;
}
.fix-overflow {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: inline-block;
    max-width: 100%;
}

.selected2{
    background-color:  #EFF6FF;
    color: #2371CC;
}

</style>


